import { FillerBody } from '@/components/FillerBody';

export const Filler = () => {
  return <FillerBody />;
};
